// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.product-tile {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  float: left;
  margin: 0 10px 20px;
  overflow: hidden;
  padding: 20px 15px 0;
  width: calc(25% - 20px);
}
.product-tile header {
  height: 40px;
  margin-bottom: 40px;
}
.product-tile a {
  display: inline-block;
  font-size: 2rem;
}
.product-tile picture {
  display: flex;
  justify-content: center;
}
.product-tile picture img {
  height: 200px;
  margin-bottom: 45px;
  position: relative;
  width: 120px;
}
.product-tile .price-info {
  line-height: 1;
  margin-bottom: 0;
}
.product-tile .price-month {
  display: inline-block;
  font-size: 3rem;
}
@media (max-width: 767px) {
  .product-tile .price-month {
    font-size: 2.2rem;
  }
}
.product-tile .product-legal {
  font-size: 1.1rem;
  height: 22px;
  line-height: 1;
  margin: 15px 0 20px;
}
.product-tile footer {
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  background-color: hsl(0, 0%, 95%);
  border-top: 1px solid #d2d2d2;
  margin-left: -15px;
  margin-right: -15px;
  padding: 15px 0;
  position: relative;
}

.catalog2column .product-tile {
  width: calc(50% - 30px);
}

.catalog4column .product-tile {
  width: calc(25% - 20px);
}

@media (max-width: 1024px) {
  .product-tile {
    float: none;
    margin: auto auto 20px;
    max-width: 320px;
    padding: 20px 10px 0;
    width: calc(100% - 30px) !important;
  }
  .product-tile header {
    margin-bottom: 20px;
  }
  .product-tile a {
    font-size: 1.4rem;
  }
  .product-tile picture {
    display: flex;
    justify-content: center;
  }
  .product-tile picture img {
    height: 170px;
    margin-bottom: 35px;
    position: relative;
    width: 120px;
  }
  .product-tile footer {
    border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    background-color: white;
    border-top: 0;
    padding: 0 0 15px;
    position: relative;
  }
  .product-tile footer button {
    background: none;
    border: 0;
    border-radius: 0;
    border-radius: 0;
    border-radius: 0;
    border-radius: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  .product-tile footer button:focus {
    outline: 0;
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/product-card/product-card.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EFiCI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EE/BF,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;AAsJF;AApJE;EACE,YAAA;EACA,mBAAA;AAsJJ;AAnJE;EACE,qBAAA;EACA,eAAA;AAqJJ;AAlJE;EACE,aAAA;EACA,uBAAA;AAoJJ;AAlJI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAoJN;AAhJE;EACE,cAAA;EACA,gBAAA;AAkJJ;AA/IE;EACE,qBAAA;EACA,eAAA;AAiJJ;AAhJI;EAHF;IAII,iBAAA;EAmJJ;AACF;AAhJE;EACE,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAkJJ;AA/IE;EFnBE,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEqBA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAqJJ;;AAhJE;EACE,uBAAA;AAmJJ;;AA9IE;EACE,uBAAA;AAiJJ;;AFnMI;EEuDF;IACE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,oBAAA;IACA,mCAAA;EAgJF;EA9IE;IACE,mBAAA;EAgJJ;EA7IE;IACE,iBAAA;EA+IJ;EA5IE;IACE,aAAA;IACA,uBAAA;EA8IJ;EA5II;IACE,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;EA8IN;EA1IE;IFtEA,0BAAA;IAAA,0BAAA;IAAA,0BAAA;IAAA,0BAAA;IAAA,0BAAA;IEwEE,uBAAA;IACA,aAAA;IACA,iBAAA;IACA,kBAAA;EAgJJ;EA9II;IACE,gBAAA;IACA,SAAA;IF/EJ,gBAAA;IAAA,gBAAA;IAAA,gBAAA;IAAA,gBAAA;IAAA,gBAAA;IEiFI,gBAAA;IACA,UAAA;EAoJN;EAlJM;IACE,UAAA;IACA,0BAAA;EAoJR;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n//product tile styles start\n.product-tile {\n  @include vendor-prefix('border-radius', 8px);\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  float: left;\n  margin: 0 10px 20px;\n  overflow: hidden;\n  padding: 20px 15px 0;\n  width: calc(25% - 20px);\n\n  header {\n    height: 40px;\n    margin-bottom: 40px;\n  }\n\n  a {\n    display: inline-block;\n    font-size: 2rem;\n  }\n\n  picture {\n    display: flex;\n    justify-content: center;\n\n    img {\n      height: 200px;\n      margin-bottom: 45px;\n      position: relative;\n      width: 120px;\n    }\n  }\n\n  .price-info {\n    line-height: 1;\n    margin-bottom: 0;\n  }\n\n  .price-month {\n    display: inline-block;\n    font-size: 3rem;\n    @media (max-width: 767px) {\n      font-size: 2.2rem;\n    }\n  }\n\n  .product-legal {\n    font-size: 1.1rem;\n    height: 22px;\n    line-height: 1;\n    margin: 15px 0 20px;\n  }\n\n  footer {\n    @include vendor-prefix('border-radius', 0 0 8px 8px);\n    background-color: color(default, base);\n    border-top: 1px solid color(default, dark);\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 15px 0;\n    position: relative;\n  }\n}\n\n.catalog2column {\n  .product-tile {\n    width: calc(50% - 30px);\n  }\n}\n\n.catalog4column {\n  .product-tile {\n    width: calc(25% - 20px);\n  }\n}\n\n@include respond-to (small) {\n  .product-tile {\n    float: none;\n    margin: auto auto 20px;\n    max-width: 320px;\n    padding: 20px 10px 0;\n    width: calc(100% - 30px) !important;\n\n    header {\n      margin-bottom: 20px;\n    }\n\n    a {\n      font-size: 1.4rem;\n    }\n\n    picture {\n      display: flex;\n      justify-content: center;\n\n      img {\n        height: 170px;\n        margin-bottom: 35px;\n        position: relative;\n        width: 120px;\n      }\n    }\n\n    footer {\n      @include vendor-prefix('border-radius', 0 0 8px 8px);\n      background-color: color(default, light);\n      border-top: 0;\n      padding: 0 0 15px;\n      position: relative;\n\n      button {\n        background: none;\n        border: 0;\n        @include vendor-prefix('border-radius', 0);\n        box-shadow: none;\n        padding: 0;\n\n        &:focus {\n          outline: 0;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n// product tile style end here\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
